import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'
import {
  type SchoolDirectoryEntryEntity,
  SchoolDirectoryEntrySchema
} from '@/core/infrastructure/schemas/school/directory/SchoolDirectoryEntrySchema.ts'

export default class SchoolDirectoryEntry {
  readonly codeUai: string
  readonly name: string
  readonly city: string
  readonly zipCode: string
  readonly address: string | null
  readonly department: string | null
  readonly schoolDistrict: string | null
  readonly contactEmail: string | null

  constructor(entry: SchoolDirectoryEntryEntity) {
    this.codeUai = entry.codeUai
    this.name = entry.name
    this.address = entry.address
    this.city = entry.city
    this.zipCode = entry.zipCode
    this.department = entry.department
    this.schoolDistrict = entry.schoolDistrict
    this.contactEmail = entry.contactEmail
  }

  /**
   * Crée une instance de SchoolInput à partir de données brutes
   */
  public static create(data: unknown): SchoolDirectoryEntry {
    return EntityValidator.validateAndCreate(SchoolDirectoryEntrySchema, data, SchoolDirectoryEntry, 'SchoolDirectoryEntry')
  }
}
